import React from 'react';
import ReactDOM from 'react-dom/client';
import AppMain from './AppMain';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppMain/>);





